// user-dashboard/components/InlineStatus.jsx
import React from "react";

/**
 * Inline status message component
 *
 * Props:
 * - message (string): The text to display
 * - type (string): one of 'success', 'danger', 'warning', 'info', 'processing'
 * - onClose (function): optional callback when closing
 * - countdown (number): optional countdown in seconds to show
 */
export default function InlineStatus({ message, type, onClose, countdown = null }) {
  if (!message) return null;

  const bgClass = {
    success: "bg-success",
    danger: "bg-danger",
    warning: "bg-warning",
    info: "bg-info",
    processing: "bg-primary",
  }[type] || "bg-secondary";

  const textClass = type === "warning" ? "text-dark" : "text-white";

  return (
    <div
      className={`${bgClass} ${textClass} px-2 py-1 rounded-2 d-inline-flex align-items-center gap-2 small`}
      style={{ fontSize: "0.75rem" }}
    >
      <span>{message}</span>
      {countdown !== null && countdown > 0 && (
        <span className="badge bg-light text-dark">{countdown}s</span>
      )}
      {onClose && (
        <button
          type="button"
          className="btn-close btn-close-white"
          style={{ fontSize: "0.6rem" }}
          onClick={onClose}
        />
      )}
    </div>
  );
}
